export const SPREADSHEET_EXTENSIONS =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xlsx, text/csv, .csv';
